export default "__VITE_ASSET__BAy5gZa7__"